import React, { useEffect, useMemo, useState } from "react";
import confirmIcon from "../../assets/svg/Vector (2).svg";
import AirportShuttleOutlinedIcon from "@mui/icons-material/AirportShuttleOutlined";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import StarsOutlinedIcon from "@mui/icons-material/StarsOutlined";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { RiCoupon3Line } from "react-icons/ri";
import { Modal } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router";
import { newHost } from "../../pages/Categories/CategoryProfile";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import { Rating, Avatar, IconButton, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { FaCheck, FaUsers } from "react-icons/fa";
import { newImageUrl } from "../../pages/Manufacturers/ManufactureProfile";
import { useSelector } from "react-redux";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const ratingPayload = () => ({ rating: 0, comment: "", reasons: [] });


const JOB_TITLE_REVIEWED_TO_OVERRIDES = {
  // "Field Technician": "technician",
};

const getReviewedTo = (type, staffJobTitle) => {
  if (type === "client") return "client";
  if (!staffJobTitle) return "staff"; 
  return JOB_TITLE_REVIEWED_TO_OVERRIDES[staffJobTitle] || staffJobTitle.toLowerCase();
};


const ReasonChips = ({ rating, selected, onToggle, fetchReasons, reviewedTo }) => {
  const [reasons, setReasons] = useState([]);
  const [loading, setLoading] = useState(false);

  const badGood = !rating ? null : rating < 3 ? "bad" : "good";
  const tone = badGood === "bad" ? { border: "#A80101", bg: "#FFF4F080" } : { border: "#3FBEAC", bg: "#ECF9F780" };

  useEffect(() => {
    if (!badGood || !reviewedTo) return;
    let ignore = false;
    setLoading(true);
    fetchReasons(badGood, reviewedTo).then((list) => {
      if (!ignore) {
        setReasons(list);
        setLoading(false);
      }
    });
    return () => {
      ignore = true;
    };
  }, [badGood, reviewedTo]);

  if (!rating) return null;

  return (
    <div className="mb-3">
      <div className="text-muted small mb-2">حدد الأسباب (اختياري)</div>

      {loading && <div className="text-muted small">جاري تحميل الأسباب...</div>}

      {!loading && (
        <div className="d-flex justify-content-center flex-wrap gap-2">
          {reasons.map((reason) => {
            const isActive = selected.includes(reason.id);
            return (
              <button
                key={reason.id}
                type="button"
                onClick={() => onToggle(reason.id)}
                className={`btn rounded-3`}
                style={{
                  transition: "all .15s ease",
                  backgroundColor: isActive ? tone.bg : "transparent",
                  border: isActive ? `1px solid ${tone.border}` : "1px solid #C6C6C6",
                }}
              >
                {reason.reason_ar}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

const RatingCard = ({ type, title, name, roleLabel, avatarUrl, entry, onChange, onBack, onSave, fetchReasons, reviewedTo }) => {
  const setRating = (val) => onChange({ ...entry, rating: val });
  const toggleReason = (reasonValue) => {
    const reasons = entry.reasons.includes(reasonValue)
      ? entry.reasons.filter((r) => r !== reasonValue)
      : [...entry.reasons, reasonValue];
    onChange({ ...entry, reasons });
  };

  return (
    <div dir="rtl">
      <div className="d-flex align-items-center gap-2 mb-1">
        <div className="">
          <IconButton disableRipple onClick={onBack}>
            <ChevronLeftIcon fontSize="medium" />
          </IconButton>
        </div>
        <div className="d-flex justify-content-center w-100">
          <h5 className="mb-0">{title}</h5>
        </div>
      </div>
      <p className="text-muted small mb-3">قيّم {type === "staff" ? "الفريق" : "العميل"} وساعدنا في تحسين جودة الخدمة</p>

      <div className="d-flex align-items-center gap-2 mb-3">
        <Avatar src={avatarUrl} alt={name} sx={{ width: 44, height: 44 }} />
        <div>
          <div className="fw-semibold">{name}</div>
          {roleLabel && <div className="text-muted small">{roleLabel}</div>}
        </div>
      </div>

      <div className="text-center mb-3">
        <Rating
          value={entry.rating}
          onChange={(_, val) => setRating(val || 0)}
          size="large"
          sx={{ fontSize: 40, color: "#f5b301", direction: "ltr" }}
        />
      </div>

      <ReasonChips
        rating={entry.rating}
        selected={entry.reasons}
        onToggle={toggleReason}
        fetchReasons={fetchReasons}
        reviewedTo={reviewedTo}
      />

      <textarea
        className="form-control mb-3"
        rows={3}
        placeholder="اكتب ملاحظتك هنا..."
        value={entry.comment}
        onChange={(e) => onChange({ ...entry, comment: e.target.value })}
      />

      <button className="btn btn-dark w-100" disabled={!entry.rating} onClick={onSave}>
        حفظ التقييم
      </button>
    </div>
  );
};

/* ============================ MAIN COMPONENT ============================ */
const ConfirmPayment = () => {
  const { user } = useSelector((state) => state.auth);
  const [currentStaff, setCurrentStaff] = useState(null);
  const token = sessionStorage.getItem("token");
  const { id: orderId } = useParams();
  const [ConfirmationShow, setConfirmationShow] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [finalTotalPrice, setFinalTotalPrice] = useState(null);
  const [expandedOrder, setExpandedOrder] = useState(null);

  const handleConfirmationShow = (total) => {
    setConfirmationShow(true);
    setFinalTotalPrice(total);
  };
  const handleConfirmationClose = () => setConfirmationShow(false);

  const navigte = useNavigate();

  const submitPayment = async () => {
    try {
      const response = await axios.get(`${newHost}stuff/confirm-payment/${orderId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success(response.data.message);
      handleConfirmationClose();
      handleCompleteMessageShow();
    } catch (error) {
      console.log(error.response);
      toast.error(error.response?.data?.errors?.message);
    }
  };

  const getOrderSummary = async () => {
    try {
      const response = await axios.get(`${newHost}stuff/get-summry-for-payment/${orderId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPaymentDetails(response.data.data?.pricing_summary);
    } catch (error) {}
  };

  useEffect(() => {
    getOrderSummary();
  }, []);
  useEffect(() => {
    if (user) {
      setCurrentStaff(`${user.stuff?.first_name} ${user.stuff?.last_name}`);
    }
  }, []);

  /* ===================== Rating / Review flow ===================== */
  const [showReview, setShowReview] = useState(false);
  const [staffList, setStaffList] = useState([]);
  const [client, setClient] = useState({});
  const [loadingReviewData, setLoadingReviewData] = useState(false);

  const [reviewStep, setReviewStep] = useState("summary");
  const [submitting, setSubmitting] = useState(false);

  const [reviews, setReviews] = useState({ client: ratingPayload(), staff: {} });

  const getCurrentStaff = async () => {
    setLoadingReviewData(true);
    try {
      const response = await axios.get(`${newHost}stuff/get-stuff-assigned-to-vehicle/${orderId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const assignedStuff = response.data.data.assignedStuff || [];
      const clientData = response.data.data.user || {};

      setStaffList(assignedStuff);
      setClient(clientData);
      setReviews({
        client: ratingPayload(),
        staff: assignedStuff.reduce((acc, s) => {
          acc[s.stuff_id] = ratingPayload();
          return acc;
        }, {}),
      });
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    } finally {
      setLoadingReviewData(false);
    }
  };

  const handleOrderReviewModalShow = async () => {
    handleCompleteMessageClose();
    setReviewStep("summary");
    setShowReview(true);
    await getCurrentStaff();
  };

  const handleOrderReviewModalClose = () => {
    setShowReview(false);
    setReviewStep("summary");
  };

  /* ===================== Reasons ===================== */
  const [reasonsCache, setReasonsCache] = useState({});

  const fetchReasons = async (badGoodType, reviewedTo) => {
    const key = `${badGoodType}_${reviewedTo}`;
    if (reasonsCache[key]) return reasonsCache[key];

    try {
      const response = await axios.get(`${newHost}stuff/review-reasons`, {
        params: { type: badGoodType, reviewed_to: reviewedTo },
        headers: { Authorization: `Bearer ${token}` },
      });
      const list = response.data?.data?.reasons || [];
      setReasonsCache((prev) => ({ ...prev, [key]: list }));
      return list;
    } catch (error) {
      console.log(error);
      return [];
    }
  };

  const submitClientReview = () =>
    axios.post(
      `${newHost}stuff/review-client/${orderId}`,
      {
        rating: reviews.client.rating,
        comment: reviews.client.comment,
        reasons: reviews.client.reasons,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );

  const submitStaffReview = () =>
    axios.post(
      `${newHost}user/orders/${orderId}/review`,
      {
        type: "stuff",
        reviews: staffList.map((s) => ({
          staff_id: s.stuff_id,
          rating: reviews.staff[s.stuff_id]?.rating || 0,
          comment: reviews.staff[s.stuff_id]?.comment || "",
          reasons: reviews.staff[s.stuff_id]?.reasons || [],
        })),
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );

  const handleSubmitAll = async () => {
    setSubmitting(true);
    const [staffRes, clientRes] = await Promise.allSettled([submitStaffReview(), submitClientReview()]);
    setSubmitting(false);

    if (staffRes.status === "rejected") {
      toast.error(staffRes.reason?.response?.data?.message);
    }
    if (clientRes.status === "rejected") {
      toast.error(clientRes.reason?.response?.data?.message);
    }

    if (staffRes.status === "fulfilled" && clientRes.status === "fulfilled") {
      toast.success("تم إرسال التقييمات بنجاح");
      handleOrderReviewModalClose();
      handleReviewMessageShow();
    }
  };

  const currentStaffEditing = useMemo(
    () => staffList.find((s) => s.stuff_id === reviewStep),
    [reviewStep, staffList]
  );

  const ratedStaffRatings = useMemo(
    () => staffList.map((s) => reviews.staff[s.stuff_id]?.rating || 0).filter((r) => r > 0),
    [staffList, reviews.staff]
  );
  const staffAvgRating = ratedStaffRatings.length
    ? ratedStaffRatings.reduce((sum, r) => sum + r, 0) / ratedStaffRatings.length
    : 0;
  const staffReviewedCount = ratedStaffRatings.length;

  const [showCompleteMessage, setShowCompleteMessage] = useState(false);

  const handleCompleteMessageShow = () => {
    setShowCompleteMessage(true);
  };
  const handleCompleteMessageClose = () => {
    setShowCompleteMessage(false);
  };
  const [showReviewMessage, setShowReviewMessage] = useState(false);

  const handleReviewMessageShow = () => {
    setShowReviewMessage(true);
  };
  const handleReviewMessageClose = () => {
    setShowReviewMessage(false);
  };

  return (
    <>
      <Modal show={showCompleteMessage} onHide={handleCompleteMessageClose} dir="rtl">
        <Modal.Body className="p-4">
          <div className="mx-auto mb-3 rounded-pill bg-secondary bg-opacity-25" style={{ width: 40, height: 4 }} />

          <div dir="rtl">
            <div className="text-center my-3">
              <div
                className="mx-auto d-flex align-items-center justify-content-center rounded-circle mb-2"
                style={{ width: 64, height: 64, backgroundColor: "#D8F3EF" }}
              >
                <FaCheck color="#3FBEAC" fontSize={30} />
              </div>
              <h6 className="mb-1">تم تأكيد الدفع</h6>
              <p className="text-muted small">شكرا لاستخدام استبن. تم اغلاق الطلب بنجاح</p>
              <div style={{ backgroundColor: "#D8F3EF80" }} className="p-3 rounded-3 ">
                <p className="label-size m-0">
                  {" "}
                  تم تأكيد استلام المبلغ <span className="fw-bold">{`${paymentDetails?.formatted?.total} ج.م`}</span>
                </p>
                <p className="label-size m-0">{`بواسطة المهندس ${currentStaff}`}</p>
              </div>
            </div>

            <button className="btn btn-light w-100 mt-3" onClick={handleOrderReviewModalShow}>
              تقييم الفريق
            </button>
            <button className="btn btn-dark w-100 mt-3" onClick={() => navigte("/ordersExecution")}>
              العودة للطلبات
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showReviewMessage} onHide={handleReviewMessageClose} dir="rtl">
        <Modal.Body className="p-4">
          <div className="mx-auto mb-3 rounded-pill bg-secondary bg-opacity-25" style={{ width: 40, height: 4 }} />

          <div dir="rtl">
            <div className="d-flex align-items-center gap-2 mb-1">
              <div className="d-flex justify-content-center w-100">
                <h5 className="mb-0">شكرًا لتقييمك</h5>
              </div>
            </div>

            <div className="text-center my-3">
              <div
                className="mx-auto d-flex align-items-center justify-content-center rounded-circle mb-2"
                style={{ width: 64, height: 64, backgroundColor: "#D8F3EF" }}
              >
                <FaCheck color="#3FBEAC" fontSize={30} />
              </div>
              <h6 className="my-1">تم استلام تقييمك بنجاح</h6>
              <p className="text-muted small">فريقنا هيطلع على ملاحظاتك لتحسين الخدمة</p>
            </div>

            <div className="border rounded-3 p-3 my-3">
              <h6 className="fw-bold mb-3">ملخص التقييم</h6>

              <div className="d-flex align-items-center justify-content-between my-3">
                <span className="small">تقييم العميل</span>
                <Rating readOnly value={reviews.client.rating} size="small" sx={{ direction: "ltr" }} />
              </div>

              <div className="d-flex align-items-center justify-content-between my-3">
                <span className="small">تقييم الفريق</span>
                <Rating readOnly precision={0.5} value={staffAvgRating} size="small" sx={{ direction: "ltr" }} />
              </div>

              <div className="d-flex align-items-center justify-content-between">
                <span className="text-muted small">عدد الفريق الذين تم تقييمهم</span>
                <span className="text-muted small">{`${staffReviewedCount}/${staffList.length}`}</span>
              </div>
            </div>

            <button className="btn btn-dark w-100 mt-3" onClick={() => navigte("/ordersExecution")}>
              العودة للصفحة الرئيسية
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {/* ================= Order Review Modal ================= */}
      <Modal show={showReview} onHide={handleOrderReviewModalClose} dir="rtl">
        <Modal.Body className="p-4">
          <div className="mx-auto mb-3 rounded-pill bg-secondary bg-opacity-25" style={{ width: 40, height: 4 }} />

          {loadingReviewData && <div className="text-center py-4 text-muted">جاري التحميل...</div>}

          {!loadingReviewData && reviewStep === "summary" && (
            <div dir="rtl">
              <div className="d-flex align-items-center gap-2 mb-1">
                <div className="">
                  <IconButton
                    disableRipple
                    onClick={() => {
                      handleCompleteMessageShow();
                      handleOrderReviewModalClose();
                    }}
                  >
                    <ChevronLeftIcon fontSize="medium" />
                  </IconButton>
                </div>
                <div className="d-flex justify-content-center w-100">
                  <h5 className="mb-0">تقييم بعد انتهاء الخدمة</h5>
                </div>
              </div>

              <div className="text-center my-3">
                <div
                  className="mx-auto d-flex align-items-center justify-content-center rounded-circle mb-2"
                  style={{ width: 64, height: 64, backgroundColor: "#D8F3EF" }}
                >
                  <FaUsers color="#3FBEAC" fontSize={30} />
                </div>
                <h6 className="mb-1">قيّم تجربتك معنا</h6>
                <p className="text-muted small">رأيك يساعدنا نحسّن خدماتنا</p>
              </div>

              <div className="text-muted small mb-1">العميل</div>
              <div
                className="d-flex align-items-center justify-content-between p-2 border rounded-3 mb-3"
                role="button"
                onClick={() => setReviewStep("client")}
              >
                <div className="d-flex align-items-center gap-2">
                  <Avatar src={`${newImageUrl}${client.profile_photo_path}`} sx={{ width: 36, height: 36 }} />
                  <div>
                    <div className="fw-semibold small">{client.name}</div>
                    <div className="text-muted" style={{ fontSize: 12 }}>
                      Order #{orderId}
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <Rating readOnly value={reviews.client.rating} size="small" sx={{ direction: "ltr" }} />
                  <button className="btn btn-sm p-0 border-0">
                    <ChevronLeftIcon fontSize="small" />
                  </button>
                </div>
              </div>

              <div className="text-muted small mb-1">الفريق</div>
              {staffList.map((s) => (
                <div
                  key={s.stuff_id}
                  className="d-flex align-items-center justify-content-between p-2 border rounded-3 mb-2"
                  role="button"
                  onClick={() => setReviewStep(s.stuff_id)}
                >
                  <div className="d-flex align-items-center gap-2">
                    <Avatar src={`${newImageUrl}${s.profile_photo_path}`} sx={{ width: 36, height: 36 }} />
                    <div>
                      <div className="fw-semibold small">{s.stuff_name}</div>
                      <div className="text-muted" style={{ fontSize: 12 }}>
                        {s.stuff_job_title}
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <Rating readOnly value={reviews.staff[s.stuff_id]?.rating || 0} size="small" sx={{ direction: "ltr" }} />
                    <button className="btn btn-sm p-0 border-0">
                      <ChevronLeftIcon fontSize="small" />
                    </button>
                  </div>
                </div>
              ))}

              <button className="btn btn-dark w-100 mt-3" disabled={submitting} onClick={handleSubmitAll}>
                {submitting ? "جاري الإرسال..." : "إرسال التقييمات"}
              </button>
            </div>
          )}

          {!loadingReviewData && reviewStep === "client" && (
            <RatingCard
              type="client"
              title="تقييم العميل"
              name={client.name}
              avatarUrl={`${newImageUrl}${client.profile_photo_path}`}
              entry={reviews.client}
              onChange={(entry) => setReviews((prev) => ({ ...prev, client: entry }))}
              onBack={() => setReviewStep("summary")}
              onSave={() => setReviewStep("summary")}
              fetchReasons={fetchReasons}
              reviewedTo={getReviewedTo("client")}
            />
          )}

          {!loadingReviewData && currentStaffEditing && (
            <RatingCard
              type="staff"
              title="تقييم الفريق"
              name={currentStaffEditing.stuff_name}
              roleLabel={currentStaffEditing.stuff_job_title}
              avatarUrl={`${newImageUrl}${currentStaffEditing.profile_photo_path}`}
              entry={reviews.staff[currentStaffEditing.stuff_id]}
              onChange={(entry) =>
                setReviews((prev) => ({
                  ...prev,
                  staff: { ...prev.staff, [currentStaffEditing.stuff_id]: entry },
                }))
              }
              onBack={() => setReviewStep("summary")}
              onSave={() => setReviewStep("summary")}
              fetchReasons={fetchReasons}
              reviewedTo={getReviewedTo("staff", currentStaffEditing.stuff_job_title)}
            />
          )}
        </Modal.Body>
      </Modal>

      {/* ================= Confirm Payment Modal ================= */}
      <Modal show={ConfirmationShow} onHide={handleConfirmationClose}>
        <Modal.Header closeButton>
          <Modal.Title className="fs-4 text-center m-0 w-100">تأكيد الدفع</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ direction: "rtl" }} className="">
          <div className="mx-3 ">
            <div className="my-3 text-center">
              <h5 className="main-modal-color">
                هل تم استلام المبلغ <span className="fw-bold">{`${finalTotalPrice} ج.م`}</span> من العميل؟
                بعد التأكيد سيتم إغلاق الطلب نهائيًا.
              </h5>
            </div>

            <div className="w-100 mt-4 d-flex align-items-center gap-3">
              <button onClick={submitPayment} className="btn btn-dark px-3 w-100">
                تم الدفع
              </button>
              <button onClick={handleConfirmationClose} className="btn btn-light px-3 w-100">
                الغاء
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <div className="m-4" dir="rtl">
        <div style={{ minHeight: "75vh" }} className="">
          <div className="w-100 d-flex justify-content-center align-items-center">
            <div className="w-100 p-3">
              <div className="text-center">
                <img src={confirmIcon} alt="" />
                <h5 className="my-2">تم انهاء الطلب بنجاح</h5>
                <p className="main-text-color my-2">في انتظار الدفع من العميل</p>
              </div>
              <div className="w-100">
                <Accordion
                  expanded={expandedOrder === orderId}
                  onChange={() => setExpandedOrder(expandedOrder === orderId ? null : orderId)}
                  sx={{
                    backgroundColor: "#ECF9F7",
                    my: 2,
                    py: 1,
                    border: "none",
                    outline: "none",
                    "&:before": {
                      display: "none",
                    },
                    "&.Mui-expanded": {
                      boxShadow: "none",
                    },
                  }}
                  className="shadow-sm"
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <div className="row w-100">
                      <div className="col-8 d-flex justify-content-start">ملخص الطلب</div>
                      <div className="col-4 d-flex justify-content-end">عرض التفاصيل</div>
                    </div>
                  </AccordionSummary>

                  <AccordionDetails>
                    <div className="my-2 d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center gap-2">
                        <p className="m-0 text-black">اجمالي الطلبات</p>
                      </div>
                      <div className="">
                        <p className="m-0 fw-bold text-black">{`${paymentDetails?.formatted?.subtotal} ج.م`}</p>
                      </div>
                    </div>
                    <div className="">
                      <div className="my-2 d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center gap-2">
                          <AirportShuttleOutlinedIcon sx={{ transform: "scaleX(-1)" }} />
                          <p className="m-0 text-black">توصيل</p>
                        </div>
                        <div className="">
                          <p className="m-0 text-black fw-semibold">{`${Number(paymentDetails?.formatted?.delivery_fee) > 0 ? `  ${Number(paymentDetails?.formatted?.delivery_fee).toLocaleString("en-US")} ج.م` : paymentDetails?.formatted?.delivery_fee}`}</p>
                        </div>
                      </div>
                      <div className="my-2 d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center gap-2">
                          <BuildOutlinedIcon sx={{ fontSize: 20 }} />
                          <p className="m-0 text-black">خدمات لم يتم تنفيذها</p>
                        </div>
                        <div className="">
                          <p className="m-0 text-danger fw-semibold">{`${Number(paymentDetails?.formatted?.rejected_items_total) > 0 ? `- ${paymentDetails?.formatted?.rejected_items_total} ج.م` : paymentDetails?.formatted?.rejected_items_total}`}</p>
                        </div>
                      </div>
                      <div className="my-2 d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center gap-2">
                          <StarsOutlinedIcon sx={{ fontSize: 20 }} />
                          <p className="m-0 text-black">{`استبدال ${paymentDetails?.breakdown?.points?.used} نقطة`}</p>
                        </div>
                        <div className="">
                          <p className="m-0 text-danger fw-semibold">{`${Number(paymentDetails?.breakdown?.points?.discount) > 0 ? `- ${Number(paymentDetails?.breakdown?.points?.discount).toLocaleString("en-US")} ج.م` : paymentDetails?.breakdown?.points?.discount}`}</p>
                        </div>
                      </div>
                      <div className="my-2 d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center gap-2">
                          <RiCoupon3Line sx={{ transform: "scaleX(-1)" }} />
                          <p className="m-0 text-black">كوبون خصم</p>
                        </div>
                        <div className="">
                          <p className="m-0 text-danger fw-semibold">{`${paymentDetails?.coupons?.applied.length > 0 ? `${Number(paymentDetails?.breakdown?.coupons?.applied[0]?.discount_amount) > 0 ? `- ${Number(paymentDetails?.breakdown?.coupons?.applied[0]?.discount_amount).toLocaleString("en-US")} ج.م` : paymentDetails?.breakdown?.coupons?.applied[0]?.discount_amount}` : 0}`}</p>
                        </div>
                      </div>
                      <div className="my-2 d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center gap-2">
                          <LocalOfferOutlinedIcon fontSize="small" />
                          <p className="m-0 text-black">برومو كود</p>
                        </div>
                        <div className="">
                          <p className="m-0 text-danger fw-semibold">{`${Number(paymentDetails?.breakdown?.promo_code?.discount) > 0 ? `- ${Number(paymentDetails?.breakdown?.promo_code?.discount).toLocaleString("en-US")} ج.م` : paymentDetails?.breakdown?.promo_code?.discount} `}</p>
                        </div>
                      </div>
                    </div>
                    <div className="border-top">
                      <div className="my-2 d-flex justify-content-between align-items-center py-1">
                        <div className="">
                          <p className="m-0 text-black">الاجمالي</p>
                        </div>
                        <div className="">
                          <p className="m-0 fw-bold text-black">{`${paymentDetails?.formatted?.total} ج.م`}</p>
                        </div>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
            </div>
          </div>
        </div>
        <div className="w-100 d-flex justify-content-center gap-2">
          <button onClick={() => handleConfirmationShow(paymentDetails?.formatted?.total)} className="btn btn-dark px-5">
            تأكيد الدفع
          </button>
        </div>
      </div>
    </>
  );
};

export default ConfirmPayment;